import { createRouter, createWebHashHistory } from 'vue-router';
// 注册路由组件

const Index = () => import('@/views/Index.vue');
const SignUp = () => import('@/views/SignUp.vue');

const Login = () => import('@/views/Login.vue');

const Books = () => import('@/views/Books.vue');

const Home = () => import('@/views/Home.vue');
const Channel = () => import('@/views/Channel.vue');
const Topic = () => import('@/views/Topic.vue');
const Topic2 = () => import('@/views/Topic2.vue');
const LiveDetail = () => import('@/views/detail/LiveDetail.vue');
const VideoDetail = () => import('@/views/detail/VideoDetail.vue');
const TextDetail = () => import('@/views/detail/TextDetail.vue');
const ImageDetail = () => import('@/views/detail/ImageDetail.vue');
const TopicDetail = () => import('@/views/detail/TopicDetail.vue');
const GroupDetail = () => import('@/views/detail/GroupDetail.vue');
const AudioDetail = () => import('@/views/detail/AudioDetail.vue');
const List = () => import('@/views/List.vue');
const zwPage = () => import('@/views/zwPage.vue');
const ydPage = () => import('@/views/ydPage.vue');
const ysPage = () => import('@/views/ysPage.vue');

const newsSource = import.meta.env.VITE_NEWS_SOURCE;
let topicType = import.meta.env.VITE_TOPIC_TYPE;
topicType = 2;
const homePage = {
  path: '/',
  name: 'index',
  meta: { keepAlive: true },
};
switch (newsSource) {
  case 'channel': {
    homePage.component = Channel;
    break;
  }
  case 'topic': {
    if (topicType === 1) {
      homePage.component = Topic;
    } else {
      homePage.component = Index;
    }
    break;
  }
  default: {
    homePage.component = Home;
    break;
  }
}

// 注册路由
const routes = [
  homePage,
  {
    path: '/login', name: 'login', component: Login, meta: { keepAlive: true, page: true },
  },
  {
    path: '/signup', name: 'signup', component: SignUp, meta: { keepAlive: true, page: true },
  },
  {
    path: '/books', name: 'books', component: Books, meta: { keepAlive: true, page: true },
  },
  {
    path: '/zwPage', name: 'zwPage', component: zwPage, meta: { keepAlive: true, page: true },
  },
  {
    path: '/zwPage', name: 'zwPage', component: zwPage, meta: { keepAlive: true, page: true },
  },
  {
    path: '/zwPage', name: 'zwPage', component: zwPage, meta: { keepAlive: true, page: true },
  },
  {
    path: '/zwPage', name: 'zwPage', component: zwPage, meta: { keepAlive: true, page: true },
  },
  {
    path: '/ydPage', name: 'ydPage', component: ydPage, meta: { keepAlive: true, page: true },
  },
  {
    path: '/ysPage', name: 'ysPage', component: ysPage, meta: { keepAlive: true, page: true },
  },
  {
    path: '/list', name: 'list', component: List, meta: { keepAlive: true },
  },
  { path: '/liveDetail', name: 'liveDetail', component: LiveDetail },
  { path: '/videoDetail', name: 'videoDetail', component: VideoDetail },
  { path: '/textDetail', name: 'textDetail', component: TextDetail },
  { path: '/imageDetail', name: 'imageDetail', component: ImageDetail },
  {
    path: '/topicDetail', name: 'topicDetail', component: TopicDetail, meta: { keepAlive: true },
  },
  {
    path: '/groupDetail', name: 'groupDetail', component: GroupDetail, meta: { keepAlive: true },
  },
  { path: '/audioDetail', name: 'audioDetail', component: AudioDetail },
];
// 创建路由实例并传递 `routes` 配置
const router = createRouter({
  // hash 模式
  history: createWebHashHistory(),
  routes,
});
export default router;
